import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

const PaymentCancel = () => (
  <div data-testid="payment-cancel-page" className="min-h-screen bg-[#F4F1EA] flex items-center justify-center px-6">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="max-w-lg text-center"
    >
      <p className="text-xs uppercase tracking-[0.3em] text-[#C85A3C] mb-4">Donation Cancelled</p>
      <h1 className="font-serif-display text-5xl font-light text-[#1A1A1A] leading-tight">
        No worries — you can give any time.
      </h1>
      <p className="mt-5 text-[#1A1A1A]/70 leading-relaxed">
        Your donation was cancelled and you were not charged. Whenever you're ready,
        we'd be honored to have your support.
      </p>
      <Link
        to="/"
        data-testid="cancel-back-home-btn"
        className="mt-10 inline-flex items-center gap-2 bg-[#1A1A1A] text-[#F4F1EA] rounded-full px-7 py-3.5 text-sm uppercase tracking-[0.15em] hover:bg-[#C85A3C] transition-colors duration-300"
      >
        <ArrowLeft size={15} /> Back Home
      </Link>
    </motion.div>
  </div>
);

export default PaymentCancel;
